
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./menu.resolver.cjs.production.min.js')
} else {
  module.exports = require('./menu.resolver.cjs.development.js')
}
